import React, { forwardRef } from "react";
import { TooltipIcon } from "@sscs/ui";
import styles from "./editPolicy.module.scss";

type RadioLabelProps = {
  label: string;
  tooltip: string;
};

const RadioLabel = forwardRef<HTMLDivElement, RadioLabelProps>(
  ({ label, tooltip }, ref) => {
    return (
      <span ref={ref} className={styles["radio-label"]}>
        {label}
        <TooltipIcon title={tooltip} />
      </span>
    );
  },
);

RadioLabel.displayName = "RadioLabel";

export default RadioLabel;
